import { KeyValues } from '../../../loader/key-values.js';

export class GlobalTargeting extends KeyValues {
}
